import { Link } from "react-router-dom";

import { DateTime } from "luxon";


import OccupationIcon from "@/assets/img/occupation.png";
import vr from "@/assets/svg/vr.svg";
import { PercentagesTotalCondition } from "@/modules/dwelling/components/sheet/Percentages.tsx";
import { DwellingDuration } from "@/modules/dwelling/containers/DwellingEstimateContainer/DwellingDuration/DwelingDuration.tsx";
import { TagChart } from "@/modules/dwelling/containers/DwellingEstimateContainer/TagChart";
import { ORDER_VIEW } from "@/modules/order/routes";

import styles from "../DwellingEstimateContainer.module.scss";
import { DwellingCost } from "../types";

export default function DwellingSection({
  dwellingId,
  data,
}: {
  dwellingId: string;
  data: DwellingCost;
}) {
  const dilapidations = data.costingToolDilapidations;
  const costingDataDwelling = data.costingData.dwelling;
  const incomingInventory = data.costingData.incomingInventory;
  const outgoingInventory = data.costingData.outgoingInventory;
  return (
    <>
      <div className={"d-flex align-items-center justify-content-between"}>
        <h2 className={styles.cardTitle}>Le bien</h2>
        {costingDataDwelling.linkVirtualVisit ? (
          <a
            target={"_blank"}
            className="btn dwelling_property-button_edit"
            href={costingDataDwelling.linkVirtualVisit}
          >
            <img src={vr} alt="visite virtuelle" />
          </a>
        ) : null}
      </div>

      <div className={"w-full d-flex align-items-center"}>
        <div className={styles.cardTopInfos}>
          <div className={styles.tenantName}>
            <span className={styles.label}>Occupant(s) :</span>
            <ul>
              {costingDataDwelling.tenants.map((tenant, key) => (
                <li key={key}>
                  <span className={styles.label}>Nom :</span> {tenant.fullName}
                  <br />
                  <span className={styles.label}>Nouvelle adresse :</span>{" "}
                  {tenant.newAddress}
                </li>
              ))}
            </ul>
          </div>

          <div className={styles.inventory}>
            {incomingInventory?.id && (
              <div className={styles.inventoryEntrance}>
                <span className={styles.label}>
                  Date état des lieux d'entrée{" "}
                  <Link
                    to={ORDER_VIEW.replace(
                      ":id",
                      incomingInventory.datedReference ||
                        incomingInventory.id ||
                        ""
                    )}
                    className="invisible-link"
                  >
                    n°{incomingInventory.datedReference || "Aucun"}
                  </Link>{" "}
                  :
                </span>{" "}
                {DateTime.fromISO(incomingInventory.date).toFormat(
                  "dd/MM/yyyy"
                )}
              </div>
            )}

            <div className={styles.inventoryExit}>
              <span className={styles.label}>
                Date état des lieux de sortie{" "}
                <Link
                  to={ORDER_VIEW.replace(
                    ":id",
                    outgoingInventory.datedReference ||
                      outgoingInventory.id ||
                      ""
                  )}
                  className="invisible-link"
                >
                  n°{outgoingInventory.datedReference}
                </Link>{" "}
                :
              </span>{" "}
              {DateTime.fromISO(outgoingInventory?.date).toFormat("dd/MM/yyyy")}
            </div>
          </div>

          <div className={styles.occupancyDuration}>
            <img
              src={OccupationIcon}
              alt="occupation"
              width="16"
              height="16"
              className="me-1"
            />
            <span className={styles.label}>Temps d'occupation :</span>{" "}
            <DwellingDuration
              dilapidations={dilapidations}
              occupationPeriod={costingDataDwelling.occupationPeriod}
            />
          </div>

          <div className={styles.ownerName}>
            <span className={styles.label}>Bailleur :</span>{" "}
            {costingDataDwelling.lessor}
          </div>

          <div className={styles.addresses}>
            <div className={styles.dwellingAddress}>
              <span className={styles.label}>Adresse du bien :</span>{" "}
              {costingDataDwelling.address}
            </div>
            <a
              target={"_blank"}
              href={`/dwelling/details/${dwellingId}`}
              className="link small"
            >
              Voir la fiche du bien
            </a>
          </div>

          <div className={styles.assetDetails}>
            <div className={styles.assetNumber}>
              <span className={styles.label}>
                Nº de lot / Invariant fiscal :
              </span>{" "}
              n°{costingDataDwelling?.lotNumber} / n°
              {costingDataDwelling?.taxNumber}
            </div>
          </div>
          <div className={styles.numbersDetails}>
            <div className={styles.dwellingTypes}>
              <span className={styles.label}>Type de bien :</span>{" "}
              {costingDataDwelling.type}, étage {costingDataDwelling?.floor},
              porte {costingDataDwelling?.door},{" "}
              {costingDataDwelling.isFurnished ? "meublé" : "non meublé"}
            </div>
          </div>
        </div>
      </div>

      <hr className={styles.hr} />
      <div className={styles.topInfoFooter}>
        <PercentagesTotalCondition
          width={"100%"}
          totalCondition={costingDataDwelling.totalCondition}
        />
        <div className={styles.tagChartContainer}>
          <TagChart
            mainValue={`${
              costingDataDwelling.totalCondition.good.percentage +
              costingDataDwelling.totalCondition.new.percentage
            }%`}
            label="Bon état et +"
          />
          <TagChart
            mainValue={`${costingDataDwelling.cleanliness}%`}
            label="Indice propreté"
          />
        </div>
      </div>
    </>
  );
}
